import { install } from "vue3-recaptcha-v2";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(install, {
    sitekey: "6LeliY4qAAAAALkD3njPmh0FL8kGWOIPMv35WY-V",
    cnDomains: false,
  });
});